module.exports = __webpack_public_path__ + "static/media/backup.5ec975d9.txt";